/* ==========================================================================
   NORDVIK — motion
   Sostituisce framer-motion con IntersectionObserver + un solo loop rAF.
   Nessuna dipendenza esterna.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     1. Reveal allo scroll — .nv-reveal / .nv-mask / .nv-fade
     --------------------------------------------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.nv-reveal, .nv-mask, .nv-fade');
    if (!els.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nv-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nv-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -70px 0px', threshold: 0.01 }
    );

    els.forEach(function (el) {
      // Le maschere dell'hero partono subito: sono già in viewport al caricamento.
      if (el.hasAttribute('data-nv-immediate')) {
        requestAnimationFrame(function () { el.classList.add('nv-in'); });
      } else {
        io.observe(el);
      }
    });
  }

  /* ---------------------------------------------------------------------
     2. Effetti legati allo scroll — un solo loop condiviso
     --------------------------------------------------------------------- */
  var scrollTargets = [];

  function lerp(a, b, t) { return a + (b - a) * t; }

  // Rimappa p da [i0,i1] a [o0,o1], con taglio agli estremi.
  function range(p, i0, i1, o0, o1) {
    if (p <= i0) return o0;
    if (p >= i1) return o1;
    return lerp(o0, o1, (p - i0) / (i1 - i0));
  }

  function collectScrollTargets() {
    scrollTargets = [];

    // --- Hero: parallasse sfondo + contenuto che sale e sfuma ---
    document.querySelectorAll('[data-nv-hero]').forEach(function (section) {
      var bg = section.querySelector('[data-nv-hero-bg]');
      var content = section.querySelector('[data-nv-hero-content]');
      if (!bg && !content) return;

      scrollTargets.push(function () {
        var rect = section.getBoundingClientRect();
        // progress: 0 quando il top tocca il top del viewport, 1 quando il bottom lo tocca
        var p = Math.min(Math.max(-rect.top / rect.height, 0), 1);

        if (bg) {
          bg.style.transform =
            'translate3d(0,' + range(p, 0, 1, 0, 28) + '%,0) scale(' +
            range(p, 0, 1, 1.05, 1.2) + ')';
        }
        if (content) {
          content.style.transform = 'translate3d(0,' + range(p, 0, 1, 0, -15) + '%,0)';
          content.style.opacity = range(p, 0, 0.7, 1, 0);
        }
      });
    });

    // --- Connect: due materassini che si uniscono ---
    document.querySelectorAll('[data-nv-connect]').forEach(function (section) {
      var left = section.querySelector('[data-nv-connect-left]');
      var right = section.querySelector('[data-nv-connect-right]');
      var pair = section.querySelector('[data-nv-connect-pair]');
      var glow = section.querySelector('[data-nv-connect-glow]');
      var caption = section.querySelector('[data-nv-connect-caption]');
      if (!left || !right) return;

      scrollTargets.push(function () {
        var rect = section.getBoundingClientRect();
        var travel = rect.height - window.innerHeight;
        var p = travel > 0 ? Math.min(Math.max(-rect.top / travel, 0), 1) : 0;

        left.style.transform =
          'translate3d(' + range(p, 0.1, 0.55, -42, 0) + '%,0,0) rotate(' +
          range(p, 0.1, 0.55, -6, 0) + 'deg)';
        right.style.transform =
          'translate3d(' + range(p, 0.1, 0.55, 42, 0) + '%,0,0) rotate(' +
          range(p, 0.1, 0.55, 6, 0) + 'deg)';

        if (pair) pair.style.gap = range(p, 0.1, 0.55, 3, 0) + 'rem';
        if (glow) glow.style.opacity = range(p, 0.4, 0.6, 0, 1);
        if (caption) caption.style.opacity = range(p, 0.55, 0.7, 0, 1);
      });
    });

    // --- Parallasse generica su immagini (Community) ---
    document.querySelectorAll('[data-nv-parallax]').forEach(function (el) {
      var amount = parseFloat(el.getAttribute('data-nv-parallax')) || 8;

      scrollTargets.push(function () {
        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom < 0 || rect.top > vh) return;
        // 0 quando entra dal basso, 1 quando esce dall'alto
        var p = (vh - rect.top) / (vh + rect.height);
        el.style.transform = 'translate3d(0,' + range(p, 0, 1, amount, -amount) + '%,0)';
      });
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking || !scrollTargets.length) return;
    ticking = true;
    requestAnimationFrame(function () {
      for (var i = 0; i < scrollTargets.length; i++) scrollTargets[i]();
      ticking = false;
    });
  }

  /* ---------------------------------------------------------------------
     3. Interazioni — funzionano sempre, anche con reduced-motion
        (selettore colore prodotto, bundle, bottoni quantità)
     --------------------------------------------------------------------- */
  function initInteractions(scope) {
    var root = scope || document;

    // --- Hero prodotto: swatch → immagine, sfondo, nome, variante, prezzo, disponibilità ---
    root.querySelectorAll('[data-nv-product]').forEach(function (group) {
      if (group.dataset.nvBound) return;
      group.dataset.nvBound = '1';

      function q(attr) {
        var sel = group.getAttribute(attr);
        return sel ? document.querySelector(sel) : null;
      }
      var frame = q('data-frame');
      var img = q('data-img');
      var nameEl = q('data-name');
      var variantInput = q('data-variant-input'); // hidden [name=id] del product-form
      var priceEl = q('data-price');
      var compareEl = q('data-compare');
      var saveEl = q('data-save');
      var atcBtn = q('data-atc');
      var soldoutLabel = group.getAttribute('data-soldout-label') || 'Esaurito';
      var buyLabel = group.getAttribute('data-buy-label') || '';
      var swatches = group.querySelectorAll('[data-nv-swatch]');

      function setImage(src) {
        if (!img || !src || img.getAttribute('src') === src) return;
        img.style.opacity = '0';
        var pre = new Image();
        function show() { img.src = src; img.style.opacity = '1'; }
        pre.onload = show;
        pre.onerror = show;
        pre.src = src;
      }

      // Variante reale: input name="id" del form + ?variant= nell'URL.
      function setVariant(vid) {
        if (!vid) return;
        if (variantInput) {
          variantInput.value = vid;
          // I bottoni di pagamento dinamici e gli altri script del tema
          // aspettano un evento, non basta scrivere .value.
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', vid);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          // URL non supportata: il carrello riceve comunque la variante giusta.
        }
      }

      function setAvailability(available) {
        if (!atcBtn) return;
        atcBtn.disabled = !available;
        var label = atcBtn.querySelector('.nv-ph__atcLabel');
        if (!label) return;
        // Memorizza una volta l'etichetta "in stock": se la pagina si apre su una
        // variante esaurita, il testo iniziale è già "Esaurito" e andrebbe perso.
        if (!label.dataset.inStock) label.dataset.inStock = buyLabel || label.textContent;
        label.textContent = available ? label.dataset.inStock : soldoutLabel;
      }

      function selectSwatch(btn) {
        if (!btn) return;

        swatches.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('nv-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        setImage(btn.getAttribute('data-image'));
        if (frame) frame.style.background = btn.getAttribute('data-bg') || '';
        if (nameEl) nameEl.textContent = btn.getAttribute('data-name') || '';

        setVariant(btn.getAttribute('data-variant-id'));

        if (priceEl && btn.hasAttribute('data-price')) priceEl.textContent = btn.getAttribute('data-price');
        if (compareEl) compareEl.textContent = btn.getAttribute('data-compare') || '';
        if (saveEl) saveEl.textContent = btn.getAttribute('data-save') || '';

        if (btn.hasAttribute('data-available')) {
          setAvailability(btn.getAttribute('data-available') === 'true');
        }
      }

      swatches.forEach(function (btn) {
        btn.addEventListener('click', function () { selectSwatch(btn); });
      });
    });

    // --- Bundle: genera le righe colore-per-pezzo dai dati e costruisce il permalink ---
    root.querySelectorAll('[data-nv-bundle-grid]').forEach(function (grid) {
      if (grid.dataset.nvBound) return;
      grid.dataset.nvBound = '1';

      var cartUrl = (grid.getAttribute('data-cart-url') || '/cart').replace(/\/$/, '');
      var colors = (grid.getAttribute('data-colors') || '').split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean);
      var hexes = (grid.getAttribute('data-hexes') || '').split(',')
        .map(function (s) { return s.trim(); });

      // mappa "Colore" -> idVariante da data-variant-map ("Arancione=123;Blu=124")
      var variantMap = {};
      (grid.getAttribute('data-variant-map') || '').split(';').forEach(function (pair) {
        var kv = pair.split('=');
        if (kv.length === 2 && kv[0]) variantMap[kv[0].trim()] = kv[1].trim();
      });

      grid.querySelectorAll('[data-nv-bundle]').forEach(function (card) {
        var qty = parseInt(card.getAttribute('data-quantity'), 10) || 1;
        var code = card.getAttribute('data-discount-code') || '';
        var buyBtn = card.querySelector('[data-nv-bundle-buy]');
        var pickers = card.querySelector('[data-nv-bundle-pickers]');
        if (!pickers || !colors.length) return;

        function syncCart() {
          var items = [];
          card.querySelectorAll('[data-nv-piece]').forEach(function (piece) {
            var active = piece.querySelector('.nv-bundle__dot.nv-active');
            if (!active) return;
            var vid = variantMap[active.getAttribute('data-color')];
            if (vid) items.push(vid + ':1');
          });
          if (!buyBtn) return;
          if (!items.length) { buyBtn.setAttribute('href', cartUrl); return; }
          var href = cartUrl + '/' + items.join(',');
          if (code) href += '?discount=' + encodeURIComponent(code);
          buyBtn.setAttribute('href', href);
        }

        var titleEl = document.createElement('p');
        titleEl.className = 'nv-bundle__pickerTitle';
        titleEl.textContent = 'Scegli i colori';
        pickers.appendChild(titleEl);

        for (var i = 1; i <= qty; i++) {
          var piece = document.createElement('div');
          piece.className = 'nv-bundle__piece';
          piece.setAttribute('data-nv-piece', '');

          var label = document.createElement('span');
          label.className = 'nv-bundle__pieceLabel';
          label.textContent = 'Pezzo ' + i;
          piece.appendChild(label);

          var dots = document.createElement('div');
          dots.className = 'nv-bundle__dots';
          colors.forEach(function (cname, ci) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'nv-bundle__dot' + (ci === 0 ? ' nv-active' : '');
            dot.style.backgroundColor = hexes[ci] || '#888888';
            dot.setAttribute('aria-label', cname);
            dot.setAttribute('data-color', cname);
            dot.addEventListener('click', function () {
              var sib = this.parentNode.querySelectorAll('.nv-bundle__dot');
              for (var s = 0; s < sib.length; s++) sib[s].classList.remove('nv-active');
              this.classList.add('nv-active');
              syncCart();
            });
            dots.appendChild(dot);
          });
          piece.appendChild(dots);
          pickers.appendChild(piece);
        }

        syncCart();
      });
    });

    // --- Form contatti: bottoni quantità che scrivono un campo nascosto ---
    root.querySelectorAll('[data-nv-qtygroup]').forEach(function (group) {
      if (group.dataset.nvBound) return;
      group.dataset.nvBound = '1';

      var hidden = group.querySelector('[data-nv-qtyvalue]');
      group.querySelectorAll('[data-nv-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-nv-qty]').forEach(function (b) {
            b.classList.remove('nv-active');
          });
          btn.classList.add('nv-active');
          if (hidden) hidden.value = btn.getAttribute('data-value') || '';
        });
      });
    });
  }

  function init() {
    initReveals();
    initInteractions();
    if (reduced) return;
    collectScrollTargets();
    if (!scrollTargets.length) return;
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // L'editor di Shopify ricarica le sezioni senza ricaricare la pagina.
  document.addEventListener('shopify:section:load', function (e) {
    initReveals();
    initInteractions(e.target || document);
    if (!reduced) { collectScrollTargets(); onScroll(); }
  });
})();